import { generateId } from "../../utils";
import { FBarData } from "./types";

type BarDataRecord = {
  displayData: FBarData[];
  filterData: FBarData[];
  idToKeysMap: Record<string, string[]>;
};

export const getBarData = (
  dataMap: Map<string, number>,
  maxBars: number,
  labelMap: Record<string, string> = {},
  selectedKeys: string[] = [],
  sortBySize = false,
  considerOtherLabelAsOtherBar = false
): BarDataRecord => {
  let barData: FBarData[] = [];
  const idToKeysMap: Record<string, string[]> = {};
  dataMap.forEach((count, key) => {
    const label = labelMap[key] || key;
    const size = count;
    const selected = selectedKeys.includes(key);
    const id = generateId();
    idToKeysMap[id] = [key];
    const isOtherBar = considerOtherLabelAsOtherBar ? label.toLowerCase() === "other" : false;

    const bar = {
      id,
      size,
      label,
      isOtherBar,
      key,
      selected,
      sizeLabel: `${size}`
    };
    barData.push(bar);
  });

  if (sortBySize) {
    barData = barData.sort((a, b) => b.size - a.size);
  }

  const slice = barData.length > maxBars + 1 ? maxBars : barData.length;
  const displayData = barData.slice(0, slice);
  const restBars = barData.slice(slice);
  let otherBar: FBarData = barData.find(bar => bar.isOtherBar) || (null as any);
  let otherBarSize = otherBar?.size || 0;

  if (restBars.length > 0) {
    const label = "Other";
    const keysArr: string[] = [];
    let selected = false;

    const size = restBars.reduce((acc, curr) => {
      const { key, size } = curr;
      keysArr.push(key);
      selected = selected || curr.selected || false;
      return acc + size;
    }, 0);

    otherBarSize = size;
    const sizeLabel = size.toString();
    const isOtherBar = true;

    const id = generateId();
    idToKeysMap[id] = keysArr;

    otherBar = {
      id,
      size,
      label,
      key: keysArr.join("|"),
      sizeLabel,
      isOtherBar,
      selected
    };

    displayData.push(otherBar);
  }

  const displayDataValues: number[] = [];
  displayData.forEach(d => {
    const { size } = d;
    !d.isOtherBar && displayDataValues.push(size);
  });

  const min = Math.min(...displayDataValues);
  const max = Math.max(...displayDataValues);

  otherBarSize = otherBarSize > max ? min + 1 : otherBarSize;
  otherBarSize = otherBarSize >= max ? 0.8 * max : otherBarSize;

  if (otherBar) {
    otherBar.size = otherBarSize;
  }

  return {
    displayData,
    filterData: restBars.length > 0 ? barData : [],
    idToKeysMap
  };
};
